import { render, staticRenderFns } from "./ServiceOrderRequestApprovalComponent.vue?vue&type=template&id=49d9dff0&"
import script from "./ServiceOrderRequestApprovalComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderRequestApprovalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports